export default __webpack_public_path__ + "static/media/logo.a9f6098e.svg";